
export enum BookingSessionStorageKeys {
    bookingTimestamp = '1',
    departureJourneyKey = '2',
    returnJourneyKey = '3',
    primaryContact = '4',
    sameForAllFlights = '5',
    stablePassengerKey = '6',
    currentSegmentSeatMap = '7',
    currentPassengerSeatMap = '8',
    manageMyBookingFlow = '9',
    checkInPreviousSelectedJourneys = '10',
    pendingPaymentDetails = '11',
    bookingPaymentMethods = '12',
    paymentAttempt = '13',
    selectedPaymentMethod = '14',
    voucherCode = '15',
    voucherAmount = '16',
    voucherApplyStatus = '17',
    invoiceRequested = '18',
    selectedPaymentTab = '19',
    organizationCreditUsed = '20',
    holdBooking = '21',

    analyticsPaymentDetails = '24',
    mappedIdsWithAnalyticsModel = '25',
    analyticsDataInSession = '26',
    dangerousGoodsTermsAndConditionsAccepted = '27',
    dataPrivacyAccepted = '28',
    skipCheckinBags = '29',
    preferredTravelDocument = '30',
    journeyStorage = '31',
    infantStorage = '32',
    maturePassengerStorage = '33',
    psoWorkersAgreementAccepted = '34',
    psoWorkersAgreementDownloaded = '35',
    psoWorkersAgreementSubmitted = '36',
    psoFamiliesAgreementAccepted = '37',
    psoFamiliesAgreementDownloaded = '38',
    psoFamiliesAgreementSubmitted = '39',
    insurancePaymentPageQuotes = '40',
    insuranceUserAgreement = '41',
    insuranceSelectedProduct = '42',
    insuranceBalanceDueAfterSelection = '43',
    neatCustomerSessionId = '44'

}